import { Extension } from '@tiptap/core'

const TAB_CHAR = '\u0009'

export function createTabHandlerExtension() {
  const onTab = ({ editor }) => {
    console.log('Handling Tab key press in TabHandlerExtension')
    editor
      .chain()
      .command(({ tr }) => {
        // Insert a tab character at the current selection
        tr.insertText(TAB_CHAR)
        return true
      })
      .run()
    return true
  }

  return Extension.create({
    name: 'tabHandler',
    priority: 99,
    addKeyboardShortcuts() {
      return {
        Tab: onTab,
        'Shift-Tab': onTab,
        Escape: ({ editor }) => {
          // Handle Escape key to exit any focused state
          if (editor.isFocused) {
            editor.blur()
            return true
          }
          return false
        },
      }
    },
  })
}
